import React from 'react'
import DashboardLayout from "../layout/Dashboard";
import { DocumentsTable } from "../../components/pages/documents/DocumentsTable";
import { FormattedMessage } from 'react-intl';
import { Messages } from '../../components/layout/Messages/Messages';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import { ACL, PAGE_CONTEXTS } from '../../config/constants';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './List.scss';

const ListDocuments = (props) => {
  return (
    <DashboardLayout
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
      {...props}
    >
      <PageWorkspace className="documents-list-workspace">
        <PageHeader title={<FormattedMessage id="pages.documents.title"/>}/>
        <div className="documents-list-notifications">
          <Messages/>
        </div>
        <PageSurface className="documents-list-surface">
          {ACL.CLIENT.DOCUMENTS.LIST.hasAccess() ?
            <DocumentsTable pageContext={PAGE_CONTEXTS.DOCUMENTS.LIST}/> : <NoRights/>}
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  )
}

export { ListDocuments }
